import React, { useState } from 'react';
import { deleteCodigoOrdenConfig } from '../../services/codigoOrdenService';
import { Trash2, X } from 'lucide-react';

type DeleteOrdenPageProps = {
    id: number;
    prefijo: string;
    onClose: () => void;
    onDeleted: (deletedId: number) => void;
};

const DeleteOrdenPage: React.FC<DeleteOrdenPageProps> = ({ 
    id, 
    prefijo,
    onClose, 
    onDeleted 
}) => {
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const handleDelete = async () => {
        setSubmitting(true);
        setError(null);
        try {
            await deleteCodigoOrdenConfig(id);
            onDeleted(id); 
            onClose();
        } catch (err) {
            /* Browser diagnostics omitted. */
            setError('Error al eliminar el código de orden');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white p-8 rounded-2xl w-full max-w-md border border-gray-100 shadow-2xl relative">
                <div className="flex justify-between items-start mb-6">
                    <h3 className="text-[20px] font-bold text-gray-900">Confirmar eliminación</h3>
                    <button 
                        onClick={onClose} 
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-6 h-6" />
                    </button>
                </div>

                {error && (
                    <p className="mb-6 text-red-500 text-sm">{error}</p>
                )}

                <p className="mb-8 text-gray-600">
                    ¿Estás seguro que deseas eliminar el código de orden con prefijo{' '}
                    <strong className="text-red-600">"{prefijo}"</strong>?
                </p>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        disabled={submitting}
                        className="px-5 py-2.5 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200 font-medium text-[14px]"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleDelete}
                        disabled={submitting}
                        className="px-5 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200 font-medium shadow-sm flex items-center text-[14px]"
                    >
                        <Trash2 className="w-4 h-4 mr-2" />
                        {submitting ? 'Eliminando...' : 'Eliminar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteOrdenPage;